import React from "react"
import { useTranslation } from "react-i18next"

import TdListCardDropdown from "./TdListCardDropdown"
import classes from "./TdListCard.module.scss"
import clsx from "clsx"

const TdListCard = props => {
  const {
    table,
    tableIndex,
    setTables,
    setLayout,
    setSelectedTable
  } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["card"]}>
      <div
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        <div>
          {t("شماره_میز")}: {table.tableNumber}
        </div>
        <div className={classes["cap"]}>
          {t("ظرفیت")}: {table.capacity}
        </div>
      </div>

      <TdListCardDropdown
        table={table}
        setTables={setTables}
        tableIndex={tableIndex}
        setLayout={setLayout}
        setSelectedTable={setSelectedTable}
      />
    </div>
  )
}

export default React.memo(TdListCard)